<app-page-header
    title="Configuración de Estados"
    mobileTitle="Estados"
    icon="fas fa-tags"
    optionsLabel="Opciones"
    optionsIcon="fa fa-cog"
    [hasOptions]="!showMobileDetail"
    [showBack]="showMobileDetail"
    [unifiedOnMobile]="showMobileDetail"
    (back)="closeDetail()">
    <div headerOptions>
        @if (perm.canCurrent('canCreate')) {
        <a class="dropdown-item" (click)="newStatusModal()">
            <i class="fas fa-plus fa-fw me-2 text-primary"></i> Nuevo estado
        </a>
        }
    </div>
</app-page-header>

@if (!showMobileDetail) {
<div class="row">
    <div class="col-12" [class.col-md-12]="!appSettings.isMobile()"
         [class.mobile-requests-container]="appSettings.isMobile()">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            <app-status-list (selectEvent)="onStatusSelected($event)">
                @if (perm.canCurrent('canCreate')) {
                <button class="btn btn-primary btn-sm" (click)="newStatusModal()">
                    <i class="fas fa-plus"></i> Nuevo Estado
                </button>
                }
            </app-status-list>
        </div>
    </div>
</div>
} @else {
<div class="panel p-3 mb-3">
    <h5 class="mb-3">{{ mode() === formMode.CREATE ? 'Nuevo estado' : 'Editar estado' }}</h5>
    <app-status-form [statusForm]="statusForm" [mode]="mode()"></app-status-form>
    @if (mode() === formMode.EDIT && selectedStatus?.isActive !== false) {
        <div class="mt-3">
            <button type="button" class="btn btn-outline-warning btn-sm w-100" (click)="deactivateSelected()">
                <i class="fas fa-ban me-1"></i> Desactivar
            </button>
        </div>
    }
</div>
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="statusForm.invalid"
        (click)="saveStatus()">
        Guardar
    </button>
</app-mobile-footer>
}

<ng-template #statusModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">{{ mode() === formMode.CREATE ? 'Nuevo' : 'Editar' }} Estado</h4>
    </div>
    <div class="modal-body">
        <app-status-form [statusForm]="statusForm" [mode]="mode()"></app-status-form>
    </div>
    <div class="modal-footer justify-content-between">
        <div>
            @if (mode() === formMode.EDIT && selectedStatus?.isActive !== false) {
                <button type="button" class="btn btn-outline-warning" (click)="deactivateSelected()">
                    <i class="fas fa-ban me-1"></i> Desactivar
                </button>
            }
        </div>
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-secondary" (click)="close()">Cancelar</button>
            <button type="button" class="btn btn-primary" (click)="saveStatus()"
                [disabled]="statusForm.invalid">
                Guardar
            </button>
        </div>
    </div>
</ng-template>
